import React from "react";

const ArticleHeader = ({ post }) => {
  // Function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };
  return (
    <div className="max-w-3xl mx-1 md:mx-36 px-4 py-6">
      {/* Post Title */}
      <header className="mb-6">
        <h1 className="text-5xl font-bold text-gray-900">{post.title}</h1>
        <p className="text-2xl text-gray-500 mt-2">{post.excerpt}</p>
      </header>

      {/* Post Meta */}
      <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-500 border-b pb-4">
        <div className="flex items-center space-x-2">
          <a
            href={`/blog/category/${post.category}/`}
            className="hover:underline text-gray-800"
          >
            {post.category}
          </a>
          <span>•</span>
          <span>{post.readMins} mins</span>
          <span>•</span>
          <time dateTime={post.date}>{formatDate(post.date)}</time>
        </div>
        <div className="flex items-center mt-2 md:mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b3/Eo_circle_purple_white_letter-n.svg"
            alt="Author"
            className="w-8 h-8 rounded-full"
          />
          <div className="ml-2">
            <span className="text-gray-700">Written by </span>
            <a
              href={post.authorLink}
              className="text-fuchsia-600 hover:underline"
            >
              {post.author}
            </a>
          </div>
        </div>
      </div>

      {/* Share Icons */}
      <div className="flex space-x-4 mt-4 text-gray-500">
        <a
          href={`https://www.facebook.com/sharer.php?u=${post.shareUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-indigo-600"
        >
          <span className="sr-only">Share on Facebook</span>
          <i className="fab fa-facebook-f"></i>
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${post.title}&url=${post.shareUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-indigo-600"
        >
          <span className="sr-only">Share on Twitter</span>
          <i className="fab fa-twitter"></i>
        </a>
        <a
          href={`mailto:?subject=${post.title}&body=${post.shareUrl}`}
          className="hover:text-indigo-600"
        >
          <span className="sr-only">Share by Email</span>
          <i className="fas fa-envelope"></i>
        </a>
      </div>

      {/* Featured Image */}
      <div className="mt-6">
        <img
          src={`${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`}
          alt={post.title}
          className="w-full rounded-lg shadow-md"
        />
      </div>
    </div>
  );
};

export default ArticleHeader;
